import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'loyaltic-how-to-steps',
    templateUrl: './how-to-steps.component.html',
    styleUrls: ['./how-to-steps.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HowToStepsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
